import type { FC } from "react";
import { Icon } from "../UI/Icon";

interface TickIconProps {
  size?: number | string;
  color?: string;
  className?: string;
}

export const TickIcon: FC<TickIconProps> = (props) => (
  <Icon {...props} viewBox="0 0 16 16">
    <path d="M14.6667 0H1.33333C0.979711 0 0.640573 0.140476 0.390524 0.390524C0.140476 0.640573 0 0.979711 0 1.33333V14.6667C0 15.0203 0.140476 15.3594 0.390524 15.6095C0.640573 15.8595 0.979711 16 1.33333 16H14.6667C15.0203 16 15.3594 15.8595 15.6095 15.6095C15.8595 15.3594 16 15.0203 16 14.6667V1.33333C16 0.979711 15.8595 0.640573 15.6095 0.390524C15.3594 0.140476 15.0203 0 14.6667 0ZM6.66667 11.6667L3.86953 8.89341C3.57511 8.60152 3.57775 8.12477 3.87537 7.83615C4.16378 7.55646 4.62262 7.55782 4.90937 7.83922L6.66667 9.56373L11.0801 5.18789C11.3712 4.89928 11.8405 4.8992 12.1317 5.18771C12.4265 5.47989 12.4266 5.95645 12.1318 6.2487L6.66667 11.6667Z" />
  </Icon>
);
